const tipoCobranza = [
  { id: 'E', label: 'Enganche' },
  { id: 'M', label: 'Mensualidad' },
];

export default tipoCobranza